import { Component, OnInit } from '@angular/core';
import { LoadConfigService } from '../../../services/load-config.service';
import { DecisionTransportService } from '../../../services/decision-transport.service';
import { InstructionService } from '../../../services/instruction.service';

@Component({
    selector: 'app-button-setup-one',
    templateUrl: './button-setup-one.component.html',
    styleUrls: ['./button-setup-one.component.scss'],
    standalone: false
})
export class ButtonSetupOneComponent implements OnInit {
  keyLabel: string;
  decisionKey: string;
  continueButtonLabel: string;

  constructor(
    private loadConfig: LoadConfigService,
    private decisionTransporter: DecisionTransportService,
    private instructionService: InstructionService
  ) {}

  ngOnInit(): void {
    this.keyLabel = this.loadConfig.getContinueLabel(this.instructionService.getLanguageIdentifier());
    this.continueButtonLabel = this.instructionService.getTranslationsForTerm('READING_MODE_CONTINUE_BUTTON');
  }

  triggerDecision(decision: boolean) {
    this.decisionTransporter.decisionTriggered(decision);
  }
}
